import axios from 'axios';

const parseUrl = (url) => {
  let link = document.createElement('a');

  link.setAttribute('href', url);

  const retValue = {
    port: link.port,
    hostname: link.hostname,
    pathname: link.pathname,
    protocol: link.protocol,
    search: link.search,
  };

  link = null;

  return retValue;
};

const getUrlAddress = (url) => {
  const newUrl = parseUrl(url);
  return `${newUrl.protocol}//${newUrl.hostname}:${newUrl.port}`;
};

const Api = () => {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['countertops-base-api-url'];
  const axiosConfig = {
    baseUrl,
    headers: { Accept: 'application/json' },
  };

  const instance = axios.create(axiosConfig);
  instance.defaults.headers.post['Content-Type'] = 'application/json';
  // instance.defaults.headers.post['X-Client-Group'] = 'blinds.com';
  // You can alter axios defaults after instance has been created from the client
  // const api = new AxiosInstance();
  // api.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  return instance;
};

export default Api;
